import React from "react";
import PropTypes from "prop-types";
import { CmsContent } from "@cars24/turbo-web/lib/cms-content";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { List } from "@cars24/turbo-web/lib/list";
import styles from "./styles.css";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { sendCustomGaEvents } from "../../../tracking";
import ArrowIcon from "./images/down-arrow.svg";

const RtoVehInfoContent = ({
    cms,
    rto,
    rtoCodeDetails
}) => {

    const {
        h2: subHeading,
        mainContent,
        subContent
    } = cms || {};
    const { tokens } = useTokens();

    const onViewChange = async () => {
        await yieldToMain();
        sendCustomGaEvents({
            event: "rto_page_read_more_clicked",
            eventCategory: "rto_page_read_more_clicked",
            eventAction: "Click on Read more"
        });
    };

    return (
        <div styleName={"styles.rtoVehInfoContent"} className="cvh">
            <Heading level={2} color={tokens.text_default_text_primary} fontWeight={"semibold"}>{subHeading}</Heading>
            <div styleName={"styles.cmsContent"}>
                <CmsContent
                    content={`${mainContent || ""} ${subContent || ""}`}
                    isExpandable={(subContent || "").length > 0}
                    expandedText={"Read less"}
                    collapsedText={"Read more"}
                    expandVariant="brand"
                    lineCount={3}
                    suffixIcon={<img src={ArrowIcon} alt={"arrow"}/>}
                    onViewChange={onViewChange}
                />
            </div>
            {
                rto && rtoCodeDetails && !!rtoCodeDetails.length &&
                <div styleName={"styles.rtoCodeDetails"}>
                    <List items={rtoCodeDetails}/>
                </div>
            }
        </div>
    );
};

RtoVehInfoContent.propTypes = {
    cms: PropTypes.object,
    rto: PropTypes.object,
    rtoCodeDetails: PropTypes.array
};

export default RtoVehInfoContent;
